import * as React from 'react';
import {RootState} from "../../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import User from "../../../../model/user/User";
import {Dispatch} from "redux";
import {logOut} from "../../../../store/action/user/user";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import "./profileMenu.scss";

interface State {
	profileDropdownVisible: boolean
}

interface DispatchProps {
	/**
	 * Sign out user from the app.
	 */
	signOut: () => void
}

interface ReduxProps {
	/**
	 * User object.
	 */
	user: User
}

type Props = ReduxProps & DispatchProps;

class ProfileMenu extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			profileDropdownVisible: false
		};
		this.openDropdown = this.openDropdown.bind(this);
		this.handleProfileOutsideClick = this.handleProfileOutsideClick.bind(this);
	}

	/**
	 * Store dropdown and button elements.
	 */
	profileDropdown: HTMLDivElement = undefined;
	profileButton: HTMLDivElement = undefined;

	componentDidMount() {
		/**
		 * Get proper DOM Nodes.
		 * @type {HTMLElement | null}
		 */
		window.addEventListener("click", this.handleProfileOutsideClick)
	}

	componentWillUnmount() {
		window.removeEventListener("click", this.handleProfileOutsideClick)
	}

	render() {
		return (
			<div className={"c-profile-menu"}>
				<div ref={(elem) => this.profileButton = elem}
					 className={"c-profile-menu_badge"} onClick={this.openDropdown}>
					{this.props.user.renderUserInitials()}
				</div>
				{this.state.profileDropdownVisible && (
					<div className={"c-profile-menu_dropdown"}
						 ref={(elem) => this.profileDropdown = elem}>
						<div className={"c-profile-menu_dropdown_header"}>
							<div className="c-profile-menu_dropdown_user-name">
								{this.props.user.getDisplayName()}
							</div>
						</div>
						<div className={"c-profile-menu_dropdown_body"}>
							<ButtonPrimary label={"Logout"} onClick={this.props.signOut}/>
						</div>
					</div>
				)}
			</div>
		);
	}

	/**
	 * Handle click outside the drop down menu and profile icon.
	 * If click target not contains stored button and dropdown, this means click was targeted outside dropdown and button
	 * - then hide dropdown.
	 */
	handleProfileOutsideClick(evt: Event) {
		if (this.state.profileDropdownVisible && !this.profileDropdown.contains(evt.target as Node) &&
			!this.profileButton.contains(evt.target as Node))
			this.setState({profileDropdownVisible: false});
	}

	/**
	 * Toggle profile drop-down visible state.
	 */
	openDropdown() {
		this.setState({profileDropdownVisible: !this.state.profileDropdownVisible})
	}
}

function mapStateToProps(state: RootState) {
	return {
		user: state.user.user.get
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		signOut: () => dispatch(logOut())
	}
}


export default connect(mapStateToProps, mapDispatchToProps)(ProfileMenu)